exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sms-img-wrap{\n\twidth: 100%;\n\tpadding-bottom: 52%;\n\tbackground-position: center center;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n}\n", ""]);

// exports
